import { InjectableClass } from "@fino/lib-injection";
import _ from "lodash";
import { OrderModel } from "./order.model";
import { NewPortfolioModel } from "../newPortfolio/newPortfolio.model";
import moment from "moment";

export class OrderService extends InjectableClass {
	constructor() {
		"ngInject";
		super();
	}

	createOrder(data) {
		// pick all but `data` options from the oldPortfolio model
		const options = _.omit(data.oldPortfolio, "data");

		// Create order model with default values
		const order = this.createOrderWithDefaults(
			data.oldBank,
			data.newBank,
			options,
		);

		this.mapCustomers(order, data.oldOwners, data.newOwners);

		// Set new portfolio values
		order.toTransfer = new NewPortfolioModel(data.newPortfolio);
		order.toTransfer.type = data.transfer.type;
		order.toTransfer.transferAllSecurities = options.transferAllSecurities;
		// important for austria
		order.options.informFinanzamtAboutSwitch =
			data.transfer.informFinanzamtAboutSwitch;

		// Set revocation value
		order.options.waiveRightOfRevocation =
			data.overview.abdicationCancellationRight;

		// Set order deadline date
		order.options.deadline = data.overview.deadline;

		// only adds signature, if signature is committed
		this.addSignatureImages(order);

		return order;
	}

	createOrderWithDefaults(oldBank, newBank, options) {
		const { legacyBankIdentifier, oldAccountNumber } = oldBank || {};
		const { portfolioId, investmentId, blz, consultantEmail } = newBank || {};
		const a = new OrderModel({
			consultantEmail,
			bankData: {
				legacyBankIdentifier: this.sanitizeValue(legacyBankIdentifier),
				oldAccountNumber: this.sanitizeValue(oldAccountNumber),
				portfolioId: this.sanitizeValue(portfolioId),
				investmentId: this.sanitizeValue(investmentId),
				newBlz: this.sanitizeValue(blz),
			},
			options: _.defaults(options, {
				transferAllSecurities: true,
				transferCapitalLoss: false,
				transferCapitalLossFromShares: false,
				transferCapitalLossFromForeignTaxes: false,
				disposeExemptionOrder: false,
				disposeSecuritiesAccount: false,
				disposeSavingsPlan: false,
				sellFragments: false,
			}),
		});
		return a;
	}

	mapCustomers(order, oldOwners, newOwners) {
		order.oldOwners = oldOwners.map(this.mapBirthdate);
		order.newOwners = newOwners.map(this.mapBirthdate);
		return order;
	}

	mapBirthdate(customer) {
		const { birthday } = customer;
		if (!birthday) return customer;

		const birthDate = moment(birthday).format("DD.MM.yyyy");

		customer.birthDate = birthDate;
		delete customer.birthday;

		return customer;
	}

	addSignatureImages(order) {
		if (order.oldOwners[0].firstName) {
			order.oldOwners.forEach((customer) => {
				if (!customer.signature || !customer.signature.dataUrl) {
					return;
				}
				customer.signature = customer.signature.dataUrl;
			});
		} else {
			order.newOwners.forEach((customer) => {
				if (!customer.signature || !customer.signature.dataUrl) {
					return;
				}
				customer.signature = customer.signature.dataUrl;
			});
		}
		return order;
	}

	sanitizeValue(value) {
		if (value === null) return null;

		// Remove whitespace from given string value
		return `${value}`.replace(/\s/g, "");
	}
}



// WEBPACK FOOTER //
// ./src/app/components/overview/order.service.js